import { render, staticRenderFns } from "./bulkCargoDetails.vue?vue&type=template&id=010d0796&scoped=true&"
import script from "./bulkCargoDetails.vue?vue&type=script&lang=js&"
export * from "./bulkCargoDetails.vue?vue&type=script&lang=js&"
import style0 from "./bulkCargoDetails.vue?vue&type=style&index=0&id=010d0796&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d0796",
  null
  
)

export default component.exports